import React, {useContext, useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import AppContext from "../../store/AppContext";
import ConsultaWhoisService from "../../services/ConsultaWhoisService";
import {ConsultaWhoisPanelResponse} from "./ConsultaWhoisPanelResponse";
import './ConsultaWhois.css';
import {TipoMensaje} from "../../store/AppProvider";
import DisponibilidadService from "../../services/DisponibilidadService";
import RecaptchaEnterprise from "../../components/recaptcha/RecaptchaEnterprise";

const REACT_APP_SITE_KEY = process.env.REACT_APP_SITE_KEY;
export const ConsultaWhois = () => {
    const appCtx = useContext(AppContext);
    const recaptchaRef = useRef();
    const [resultadoConsultaWhois, setResultadoConsultaWhois] = useState(undefined);
    const [dominio, setDominio] = useState('');
    const [dominiosHabilitados, setDominiosHabilitados] = useState('');
    const [captchaResponse, setCaptchaResponse] = useState('');
    const [showCaptcha, setShowCaptcha] = useState(true);
    const [loading, setLoading] = useState(false);
    let location = useLocation();
    let history = useNavigate();
    const [dominioPendiente, setDominioPendiente] = useState(null);

    useEffect(() => {
        obtenerDominiosHabilitados();

        mostrarCaptcha().then(() => {
            if (location.state?.dominioDisponibilidad) {
                const dominioDisponibilidad = location.state.dominioDisponibilidad;
                setDominio(dominioDisponibilidad);
                setDominioPendiente(dominioDisponibilidad);
            }
        });

        appCtx.ocultarMensaje();
    }, []);


    useEffect(() => {
        if (showCaptcha === false && dominioPendiente) {
            consultaWhoisService(dominioPendiente);
            setDominioPendiente(null);
        }
    }, [showCaptcha, dominioPendiente]);


    const consultarWhois = (e) => {
        e.preventDefault();

        const nombreDominio = eliminarEspacios(dominio || '');
        if (!nombreDominio) {
            appCtx.mostrarMensaje('Ingrese el nombre del dominio que desea consultar.', TipoMensaje.warning);
            return;
        }
        setDominio(nombreDominio);

        let nombreDominioAscii;
        try {
            nombreDominioAscii = new URL(`http://${nombreDominio}`).hostname;
        } catch (error) {
            appCtx.mostrarMensaje('El dominio ingresado tiene formato inválido. Asegúrate de que esté en el formato correcto.', TipoMensaje.error);
            return;
        }

        if (!validarDominio(nombreDominioAscii.toLowerCase())) {
            if (showCaptcha) {
                recaptchaRef.current.reset();
            }

            // Dividir el dominio en partes
            const partesDominio = nombreDominioAscii.split('.');
            if (partesDominio.length < 2 || partesDominio.length > 3) {
                appCtx.mostrarMensaje('El dominio no tiene un formato válido. Asegúrate de que esté en el formato correcto (ejemplo: peñarol.com.uy).', TipoMensaje.error);
                return;
            }

            const tld = partesDominio.slice(-2).join('.');
            if (tld !== 'com.uy' && tld !== 'uy') {
                appCtx.mostrarMensaje('El dominio ingresado debe terminar en .com.uy o .uy', TipoMensaje.error);
                return;
            }

            if (nombreDominio.includes(' ')) {
                appCtx.mostrarMensaje('El dominio no debe contener espacios.', TipoMensaje.error);
                return;
            }

            appCtx.mostrarMensaje('El dominio ingresado tiene formato inválido. Debe terminar en .com.uy o .uy', TipoMensaje.error);
            return;
        }

        if (showCaptcha && !captchaResponse) {
            appCtx.mostrarMensaje('Debe completar el captcha.', TipoMensaje.error);
            return;
        }

        consultaWhoisService(nombreDominio);
    };

    const consultaWhoisService = (dominio) => {
        const dominoConsulta = dominio.toLowerCase();
        setLoading(true);
        ConsultaWhoisService.getWhois(dominoConsulta, captchaResponse, showCaptcha)
            .then(response => {
                if (response.esRespOK || response.respCodigo === 'ERROR_DOMINIO_NO_EXISTE') {
                    appCtx.ocultarMensaje();
                    setResultadoConsultaWhois(response);
                    setDominio(response.dominio);

                    if (showCaptcha) {
                        recaptchaRef.current.reset();
                    }
                    setCaptchaResponse('');
                    mostrarCaptcha();
                }
                else if (response.respCodigo === 'CAPTCHA_INVALIDO') {
                    appCtx.mostrarMensaje('El captcha no se validó correctamente. Inténtelo nuevamente.', TipoMensaje.error);
                    setResultadoConsultaWhois(undefined);
                }

                else if (response.respCodigo === 'PARAMETRO_REQUERIDO') {
                    appCtx.mostrarMensaje(response.respMensaje + " Debe terminar en " + dominiosHabilitados, TipoMensaje.error);
                    setResultadoConsultaWhois(undefined);
                }
                else if (response.respCodigo === 'ERROR_DOMINIO_NO_PERTENECE') {
                    appCtx.mostrarMensaje(response.respMensaje, TipoMensaje.warning);
                    setResultadoConsultaWhois(undefined);
                }
                else if (response.respCodigo === 'CAPTCHA_REQUERIDO') {
                    appCtx.mostrarMensaje('Es necesario validar el captcha para continuar.', TipoMensaje.warning);
                    setShowCaptcha(true);
                    setResultadoConsultaWhois(undefined);
                }
                else {
                    appCtx.mostrarMensaje('Lo sentimos, ha ocurrido un error. Por favor, inténtelo nuevamente.', TipoMensaje.error);
                    setResultadoConsultaWhois(undefined);
                }
            })
            .catch(() => {
                appCtx.mostrarMensaje('Lo sentimos, ha ocurrido un error. Por favor, inténtelo nuevamente.', TipoMensaje.error);
                setResultadoConsultaWhois(undefined);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const obtenerDominiosHabilitados = () => {
        DisponibilidadService.getDominiosHabilitados().then((response) => {
            if (response && response.respuestaOK) {
                let domsHabilitados = '';
                for (let index = 0; index < response.dominiosHabilitados.length; index++) {
                    if (response.dominiosHabilitados.length === index + 1) {
                        domsHabilitados = domsHabilitados + response.dominiosHabilitados[index];
                    } else {
                        if (response.dominiosHabilitados.length === index + 2) {
                            domsHabilitados = domsHabilitados + response.dominiosHabilitados[index] + ' o ';
                        } else {
                            domsHabilitados = domsHabilitados + response.dominiosHabilitados[index] + ", ";
                        }
                    }
                    setDominiosHabilitados(domsHabilitados);
                }
            }
        })
    }

    const mostrarCaptcha = () => {
        return DisponibilidadService.mostrarCaptcha().then(response => {
            if (response !== undefined && response.codigo === 'OK') {
                setShowCaptcha(response.resultado);
            }
            return response;
        });
    };


    const handleOnChange = (e) => {
        const { value } = e.target;
        setDominio(value);
    }

    function onChange(value) {
        setCaptchaResponse(value);
    }

    function eliminarEspacios(cadena) {
        return cadena.replace(/\s/g, '');
    }

    function validarDominio(dominio) {
        // Expresión regular para validar dominios que terminan en ".com.uy" o ".uy"
        const regexDominio = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?)+(?:\.com\.uy|\.uy)$/;
        return regexDominio.test(dominio);
    }

    return <>
        <h2>Consultar Whois</h2>
        <div className="whois-search">
            <form id="id-form-whois-query" name="id-form-whois-query" onSubmit={consultarWhois}>
                <div>
                    <p>Este servicio le permite conocer la información pública de los dominios y sus contactos.</p>
                    <input type="text" name="text" maxLength={50} value={dominio} onChange={handleOnChange} />
                    <input type="submit" value="Buscar" disabled={loading}/>
                    { showCaptcha &&
                        <div className={"box-captcha cfx"}>
                        <RecaptchaEnterprise
                            ref={recaptchaRef}
                            siteKey={REACT_APP_SITE_KEY}
                            action="WHOIS"
                            onChange={onChange}
                        />
                    </div>}
                </div>
            </form>
        </div>

        { resultadoConsultaWhois?
            <ConsultaWhoisPanelResponse isCaptchaVisible={showCaptcha} resultadoConsultaWhois={resultadoConsultaWhois}/> : <></>
        }
    </>
}